export default "__VITE_ASSET__CaIokILN__"